module.exports = __webpack_public_path__ + "img/authBgy.bd7f6f61.png";